
import { useState, useEffect ,useContext} from "react";
import "../../assets/css/ngodashboard/LevelBadgeManagement.css";
import NGOMasterLayout from '../../components/layout/NGOMasterLayout';
import AppContext from "../../context/AppContext";

const Icons = {
  Plus: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
  Edit: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Trash: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    </svg>
  ),
  Badge: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <circle cx="12" cy="8" r="6" />
      <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
    </svg>
  ),
  Close: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
};

// ── Delete Modal ─────────────────────────────────────────────
function DeleteModal({ item, onCancel, onConfirm }) {
  return (
    <div className="lbm-modal-overlay" onClick={onCancel}>
      <div className="lbm-modal-box lbm-delete-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Delete Badge</h3>
        <p>Are you sure you want to delete <strong>{item.title}</strong>?</p>
        <div className="lbm-modal-footer">
          <button className="lbm-btn-ghost" onClick={onCancel}>Cancel</button>
          <button className="lbm-btn-danger" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
}

// ── Badge Modal — sirf Title, Trigger, Amount ────────────────
function BadgeModal({ editItem, onClose, onSave }) {
  const [title,       setTitle]       = useState(editItem?.title       || "");
  const [trigger,     setTrigger]     = useState(editItem?.trigger     || "");
  const [rewardValue, setRewardValue] = useState(editItem?.rewardValue || "");
  const [error,       setError]       = useState("");

  const handleSave = () => {
    if (!title.trim())   { setError("Badge name required hai."); return; }
    if (!trigger)        { setError("Donations trigger required hai."); return; }
    if (!rewardValue)    { setError("Reward amount required hai."); return; }

    onSave({
      title:       title.trim(),
      type:        "Badge",           // always Badge
      trigger:     Number(trigger),
      rewardValue: parseFloat(rewardValue),
    });
  };

  return (
    <div className="lbm-modal-overlay" onClick={onClose}>
      <div className="lbm-modal-box lbm-add-modal" onClick={(e) => e.stopPropagation()}>
        <div className="lbm-modal-header">
          <h2>{editItem ? "Edit Badge" : "Add Badge"}</h2>
          <button onClick={onClose}><Icons.Close /></button>
        </div>

        <div className="lbm-modal-body">
          {error && (
            <div style={{
              background: "#fff0f0", border: "1px solid #f5c6cb",
              color: "#dc3545", borderRadius: "8px",
              padding: "10px 14px", marginBottom: "14px", fontSize: "0.88rem"
            }}>
              {error}
            </div>
          )}

          <div className="lbm-field-group">
            <label>Badge Name <span style={{ color: "red" }}>*</span></label>
            <input
              className="lbm-field-input"
              placeholder="e.g. Bronze Donor"
              value={title}
              onChange={(e) => { setTitle(e.target.value); setError(""); }}
            />
          </div>

          <div className="lbm-field-group">
            <label>Donations Required <span style={{ color: "red" }}>*</span></label>
            <input
              type="number"
              min="1"
              className="lbm-field-input"
              placeholder="e.g. 5"
              value={trigger}
              onChange={(e) => { setTrigger(e.target.value); setError(""); }}
            />
            <small style={{ color: "#888", marginTop: "4px", display: "block" }}>
              Donor itni donations kare toh yeh badge mile ga
            </small>
          </div>

          <div className="lbm-field-group">
            <label>Reward Amount (Rs.) <span style={{ color: "red" }}>*</span></label>
            <input
              type="number"
              min="0"
              className="lbm-field-input"
              placeholder="e.g. 500"
              value={rewardValue}
              onChange={(e) => { setRewardValue(e.target.value); setError(""); }}
            />
            <small style={{ color: "#888", marginTop: "4px", display: "block" }}>
              Badge earn hone pe donor ko yeh amount withdrawal mein milegi
            </small>
          </div>
        </div>

        <div className="lbm-modal-footer">
          <button className="lbm-btn-ghost" onClick={onClose}>Cancel</button>
          <button className="lbm-btn-primary" onClick={handleSave}>Save Badge</button>
        </div>
      </div>
    </div>
  );
}

// ── Main Component ───────────────────────────────────────────
const LevelBadgeManagement = () => {
  const { baseUrl } = useContext(AppContext);
  const [badges,       setBadges]       = useState([]);
  const [showModal,    setShowModal]    = useState(false);
  const [editItem,     setEditItem]     = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [search,       setSearch]       = useState("");
  const [toast,        setToast]        = useState(null);

  useEffect(() => { fetchBadges(); }, []);

  const fetchBadges = async () => {
    try {
      const res = await fetch(`${baseUrl}/badge-levels`);
      const data = await res.json();
      // sirf Badge type show karo
      const all = Array.isArray(data) ? data : data.data || [];
      setBadges(all.filter((b) => b?.type === "Badge" || !b?.type));
    } catch (err) {
      console.log(err);
      setBadges([]);
    }
  };

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleSave = async (data) => {
    try {
      const url    = editItem
        ? `${baseUrl}/badge-levels/${editItem.id}`
        : `$ {baseUrl}/badge-levels`;
      const method = editItem ? "PUT" : "POST";

      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify(data),
      });

      if (!res.ok) {
        showToast("Kuch ghalat hua, dobara try karein.", "error");
        return;
      }

      showToast(editItem ? "Badge updated!" : "Badge created!");
      fetchBadges();
      setShowModal(false);
      setEditItem(null);
    } catch (err) {
      console.log(err);
      showToast("Server se connection nahi hua.", "error");
    }
  };

  const handleDelete = async () => {
    try {
      
      const res = await fetch(`${baseUrl}/badge-levels`);
      fetchBadges();
      showToast("Badge deleted.", "error");
      setDeleteTarget(null);
    } catch (err) {
      console.log(err);
    }
  };

  const filtered = badges.filter((b) =>
    (b?.title || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="lbm-root">
      <NGOMasterLayout>

        {/* HEADER */}
        <header className="lbm-header">
          <div className="lbm-header-left">
            <Icons.Badge />
            <div>
              <h1 className="lbm-header-title">Badge Management</h1>
            </div>
          </div>
          <button className="lbm-btn-primary" onClick={() => { setEditItem(null); setShowModal(true); }}>
            <Icons.Plus /> Add Badge
          </button>
        </header>

        {/* STATS */}
        <div className="lbm-stat-row">
          <div className="lbm-stat-card">
            <span className="lbm-stat-num">{badges.length}</span>
            <span>Total Badges</span>
          </div>
          <div className="lbm-stat-card">
            <span className="lbm-stat-num">
              Rs. {badges.reduce((s, b) => s + (Number(b.rewardValue) || 0), 0).toLocaleString()}
            </span>
            <span>Total Reward Pool</span>
          </div>
        </div>

        {/* SEARCH */}
        <div className="lbm-toolbar">
          <input
            className="lbm-search-input"
            placeholder="Search badges..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* TABLE */}
        <div className="lbm-table-card">
          <table className="lbm-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Badge Name</th>
                <th>Donations Required</th>
                <th>Reward Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length > 0 ? (
                filtered.map((b, idx) => (
                  <tr key={b.id}>
                    <td>{idx + 1}</td>
                    <td><strong>{b.title}</strong></td>
                    <td>{b.trigger} donations</td>
                    <td style={{ color: "#1F7A7A", fontWeight: 700 }}>
                      Rs. {(Number(b.rewardValue) || 0).toLocaleString()}
                    </td>
                    <td>
                      <div className="lbm-action-btns">
                        <button className="lbm-action-btn lbm-action-edit" onClick={() => { setEditItem(b); setShowModal(true); }} title="Edit">
                          <Icons.Edit />
                        </button>
                        <button className="lbm-action-btn lbm-action-delete" onClick={() => setDeleteTarget(b)} title="Delete">
                          <Icons.Trash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", padding: "2rem", color: "#888" }}>
                    🎖️ Koi badge nahi — pehla badge add karo!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* MODALS */}
        {showModal && (
          <BadgeModal
            editItem={editItem}
            onClose={() => { setShowModal(false); setEditItem(null); }}
            onSave={handleSave}
          />
        )}
        {deleteTarget && (
          <DeleteModal
            item={deleteTarget}
            onCancel={() => setDeleteTarget(null)}
            onConfirm={handleDelete}
          />
        )}

        {/* TOAST */}
        {toast && <div className={`lbm-toast lbm-toast-${toast.type}`}>{toast.msg}</div>}

      </NGOMasterLayout>
    </div>
  );
};

export default LevelBadgeManagement;